import { Component, OnInit, Input } from '@angular/core';
import { NewsletterTimestamp } from '../../components/user/newsletterTimestamp';
import { UserManagerService } from '@app/managers';
import { User } from '../user/user';
import { Parameters } from '@app/components/parameters/parameters';
import { ParametersService } from '../parameters/parameters.service';
import { NewsletterService } from '@app/services';
import { DatePipe, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.scss'],
    imports: [NgClass, TranslateModule, DatePipe]
})
export class NewsletterComponent implements OnInit {
    @Input() lang: string;
    @Input() newsletterTimestamps: NewsletterTimestamp[];

    currentNewsletterState: NewsletterTimestamp;
    params: Parameters;

    user: User;

    constructor(
        private readonly userManagerService: UserManagerService,
        private readonly parametersService: ParametersService,
        private readonly newsletterService: NewsletterService
    ) { }

    ngOnInit(): void {
        this.parametersService.getParametersObservable().subscribe(par => {
            this.params = par;
            this.user = this.params.user;

            this.currentNewsletterState = this.user.newsletterTimestamps.find(x => Math.max.apply(x.dateOfChange) && x.lang === this.lang);

            if (!this.currentNewsletterState) {
                this.currentNewsletterState = {
                    dateOfChange: undefined,
                    iPAddress: '',
                    lang: this.lang,
                    wantsNewsletter: false
                };
            }
        });

        this.newsletterService.getNewsletter(this.user.email).subscribe(res => {
            if (res?.success) {
                // check if user already signed up for newsletter on homepage -> if true: add newsletter for user also to myPöttinger-DB
                const newslettersUser = this.user.newsletterTimestamps;
                res.data.forEach(element => {
                    if (!newslettersUser.some(n => n.lang === element.lang)) {
                        const newNewsletter: NewsletterTimestamp = {
                            dateOfChange: element.dateOfChange,
                            lang: element.lang,
                            iPAddress: '',
                            wantsNewsletter: true
                        };
                        newslettersUser.push(newNewsletter);
                    }
                });

                this.user.newsletterTimestamps = newslettersUser;
                this.saveUserData();
            }
        });
    }

    onSignup(): void {
        this.currentNewsletterState.dateOfChange = new Date();
        this.currentNewsletterState.iPAddress = '';
        this.currentNewsletterState.wantsNewsletter = true;

        this.user.newsletterTimestamps.push(this.currentNewsletterState);
        this.saveUserData();

        this.newsletterService.addNewsletter(this.user, this.lang).subscribe();
    }

    onSignout(): void {
        const selectedNewsletter = this.user.newsletterTimestamps.filter(n => n.lang !== this.lang);
        this.user.newsletterTimestamps = selectedNewsletter;
        this.saveUserData();

        this.newsletterService.deleteNewsletter(this.user.email, this.lang).subscribe();
    }

    saveUserData(): void {
        this.userManagerService.updateUser(this.user).subscribe(x => {
            this.parametersService.setUser(x);
        });
    }
}
